class paginationView {
  // blogPage = document.querySelector(".blog_");
  blog = document.querySelector(".blog");
  button = document.querySelector(".btn--inline");
  main = document.querySelector("main");
  pagination = document.querySelector(".pagination");
  pag = document.querySelector(".pag");

  _addHandler(handler, returned) {
    this.main.addEventListener("click", function (e) {
      const target = e.target.closest(".pag");
      if (target) {
        e.preventDefault();
        console.log(+target.dataset.tab);
        handler(+target.dataset.tab, returned);
      }
      if (!target) return;
    });
  }

  _render(data, perPge, curpage) {
    const numPages = Math.ceil(data.length / perPge);

    for (let index = numPages; index > 0; index--) {
      const element = `  <li data-tab="${index}" class="pag">
      <a href="#" class="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">${index}</a>
    </li>`;

      this.pagination
        ? this.pagination.insertAdjacentHTML("afterbegin", element)
        : "";
    }
  }

  _clear() {
    console.log(this.button);
  }
}

export default new paginationView();
